import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { ExcelProjectImport_ModuleContextService } from './ExcelProjectImport.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ExcelProjectImport_excel_project_import_grid_ComponentContextService {
  private readonly moduleContext: ExcelProjectImport_ModuleContextService;

  constructor(moduleContext: ExcelProjectImport_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'excel_project_import_grid',
      type: ComponentType.grid
    }
  }
}